import { routes } from 'routes';

export const usePathToVideoDetail = () => {
  return (id: string) => {
    return routes.video.detail(id);
  };
};
